import { useQuery } from "@tanstack/react-query";
import ParameterBinding from "views/logic/parameters/ParameterBinding";
import fetch from "logic/rest/FetchProvider";
import URLUtils from "util/URLUtils";
import { migrateWidgetValueResult } from "report/report-render-page/fetchAdhocReportValues";
const sourceUrl = "/plugins/org.graylog.plugins.report";
const fetchReportingWidgetValue = (dashboardId, widgetId, parameterBindings = {}, globalOverride = {}) => {
  const request = {
    parameter_bindings: Object.fromEntries(
      Object.entries(parameterBindings).map(([key, value]) => [
        key,
        ParameterBinding.create("value", value)
      ])
    ),
    global_override: globalOverride
  };
  return fetch("POST", URLUtils.qualifyUrl(`${sourceUrl}/widgets/${dashboardId}/${widgetId}/value`), request).then(
    (result) => migrateWidgetValueResult(result)
  );
};
const useWidgetResult = ({
  dashboardId,
  widgetId,
  parameterValues = void 0,
  globalOverride = void 0,
  enabled = true,
  staleTime = 0
}) => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["report.widget.preview", dashboardId, widgetId, parameterValues, globalOverride],
    queryFn: () => fetchReportingWidgetValue(dashboardId, widgetId, parameterValues, globalOverride),
    enabled,
    staleTime
  });
  return {
    data,
    isLoading,
    isError,
    error
  };
};
export default useWidgetResult;
